import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["open", "defaultOpen", "onOpenChange", "onClose", "zIndex", "enablePortal", "enableBackdrop", "disableOverlay", "enableCloseButton", "isCloseButtonVisible", "enableCloseByEscape", "disableCloseByEscape", "enableCloseOnBackdropClick", "enableWindowScrollBlock", "enableEffects", "disableEffects", "isFixed", "wide"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback } from 'react';
import { sideSheetContent, sideSheetHeaderContainer } from '../constants';
import { useControlledFlagState, useOverlay, useDisplayEffects, useDocumentKeydown, useRootRef } from '../../../system';
export var useSideSheet = function useSideSheet(_ref, ref) {
  var open = _ref.open,
      defaultOpen = _ref.defaultOpen,
      onOpenChange = _ref.onOpenChange,
      onClose = _ref.onClose,
      zIndex = _ref.zIndex,
      enablePortal = _ref.enablePortal,
      enableBackdrop = _ref.enableBackdrop,
      disableOverlay = _ref.disableOverlay,
      enableCloseButton = _ref.enableCloseButton,
      isCloseButtonVisible = _ref.isCloseButtonVisible,
      enableCloseByEscape = _ref.enableCloseByEscape,
      disableCloseByEscape = _ref.disableCloseByEscape,
      enableCloseOnBackdropClick = _ref.enableCloseOnBackdropClick,
      enableWindowScrollBlock = _ref.enableWindowScrollBlock,
      enableEffects = _ref.enableEffects,
      disableEffects = _ref.disableEffects,
      isFixed = _ref.isFixed,
      wide = _ref.wide,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var reallyEnableCloseButton = enableCloseButton !== undefined ? enableCloseButton : isCloseButtonVisible;
  var reallyEnableCloseByEscape = enableCloseByEscape !== undefined ? enableCloseByEscape : !disableCloseByEscape;
  var reallyEnableBackdrop = enableBackdrop !== undefined ? enableBackdrop : !disableOverlay;
  var reallyEnableEffects = enableEffects !== undefined ? enableEffects : !disableEffects;

  var _useControlledFlagSta = useControlledFlagState(defaultOpen, open, onOpenChange),
      _useControlledFlagSta2 = _slicedToArray(_useControlledFlagSta, 4),
      reallyOpen = _useControlledFlagSta2[0],
      setClose = _useControlledFlagSta2[3];

  var _useOverlay = useOverlay(reallyOpen, {
    zIndex: zIndex,
    blockWindowScroll: enableWindowScrollBlock !== false
  }),
      realZIndex = _useOverlay.zIndex,
      isTopOverlay = _useOverlay.isTopOverlay;

  var onCloseInternal = useCallback(function () {
    if (isTopOverlay()) {
      if (onClose) {
        onClose();
      }

      setClose();
    }
  }, [onClose, setClose, isTopOverlay]);
  var rootRef = useRootRef(ref);
  var onBackdropClick = useCallback(function () {
    if (reallyEnableBackdrop && enableCloseOnBackdropClick !== false) {
      onCloseInternal();
    }
  }, [onCloseInternal, enableCloseOnBackdropClick, reallyEnableBackdrop]);

  var _useDisplayEffects = useDisplayEffects(reallyOpen),
      display = _useDisplayEffects.display,
      effectToggle = _useDisplayEffects.effectToggle;

  var onKeyDown = useCallback(function (event) {
    if (!reallyEnableCloseByEscape || event.key !== 'Escape' || !isTopOverlay()) {
      return;
    }

    onCloseInternal();
  }, [isTopOverlay, onCloseInternal, reallyEnableCloseByEscape]);
  useDocumentKeydown(onKeyDown);
  return {
    portalProps: {
      enablePortal: enablePortal
    },
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: rootRef,
      zIndex: realZIndex
    }),
    getBackdropProps: function getBackdropProps() {
      return {
        disableEffects: !reallyEnableEffects,
        display: display,
        effectToggle: effectToggle,
        onClick: onBackdropClick
      };
    },
    windowProps: {
      disableEffects: !reallyEnableEffects,
      display: display,
      effectToggle: effectToggle,
      wide: wide
    },
    contentProps: {
      'data-testid': sideSheetContent
    },
    headerContainerProps: {
      'data-testid': sideSheetHeaderContainer
    },
    getCloseButtonProps: function getCloseButtonProps() {
      return {
        onClick: onCloseInternal
      };
    },
    isCloseButtonVisible: isCloseButtonVisible,
    wide: wide,
    isFixed: isFixed,
    enableCloseButton: reallyEnableCloseButton,
    enableBackdrop: reallyEnableBackdrop
  };
};